export type TimeOffDayPortion = "fullDay" | "firstHalf" | "secondHalf";

const portionsByNumber: Record<number, TimeOffDayPortion> = {
  0: "fullDay",
  1: "firstHalf",
  2: "secondHalf",
};

export const normalizeTimeOffDayPortion = (
  dayPortion: unknown,
  isHalfDay = false,
): TimeOffDayPortion => {
  if (typeof dayPortion === "number") {
    return portionsByNumber[dayPortion] ?? "fullDay";
  }

  if (typeof dayPortion === "string") {
    const normalized = dayPortion.replace(/[\s_-]/g, "").toLowerCase();
    if (normalized === "firsthalf" || normalized === "1") return "firstHalf";
    if (normalized === "secondhalf" || normalized === "2") return "secondHalf";
    if (normalized === "fullday" || normalized === "0") return "fullDay";
  }

  // Older API records only contain IsHalfDay. Keep them visibly half-day
  // without guessing that they occupy the second half.
  return isHalfDay ? "firstHalf" : "fullDay";
};

export const timeOffDayPortionLabel = (
  dayPortion: unknown,
  isHalfDay = false,
) => {
  const normalized = normalizeTimeOffDayPortion(dayPortion, isHalfDay);
  if (normalized === "firstHalf") return "First half";
  if (normalized === "secondHalf") return "Second half";
  return "Full day";
};
